import React, { useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import SelectListField from "../../../components/Fields/SelectListField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import DataService from "../../../services/data.service";
import { ItemTypePopupProps } from "../../../types/PopupProps";
import { DataResult } from "../../../types/Result";

interface ItemTypeWorkflowRole {
    itemTypeId: number | undefined
    workflowDefinitionId: number
}

const AddItemTypeWorkflowDefinitionPopup: React.FC<ItemTypePopupProps> = ({ show, onHide, itemTypeId }) => {
    const [serverErrors, setServerErrors] = useState<DataResult<ItemTypeWorkflowRole>>({ isSuccesful: true, messages: [], data: undefined });
    const { handleResult, handleException } = useNotifications();

    const [formData, setFormData] = useState<ItemTypeWorkflowRole>({
        itemTypeId: itemTypeId,
        workflowDefinitionId: 0,
    });

    const workflows = useSelectListOptions('api/v1/selectlist/WorkflowDefinitions', '-- Select workflow');

    function submit() {
        if (formData) {
            DataService
                .create<ItemTypeWorkflowRole>(`api/v1/ItemTypeWorkflowDefinitions/`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true && response.data)
                        setFormData(response.data);

                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'workflowDefinitionId', label: 'Workflow', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Add workflow'} >
            <Popup.Body>
                <SelectListField {...getFieldProps('workflowDefinitionId')} options={workflows} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} text='Add' />
            </Popup.Footer>
        </Popup>
    );
}
export default AddItemTypeWorkflowDefinitionPopup;